import InvestorIcon from '@material-ui/icons/People';

import InvestorList from './InvestorList';
import InvestorCreate from './InvestorCreate';
import InvestorEdit from './InvestorEdit';

export default {
  list: InvestorList,
  edit: InvestorEdit,
  create: InvestorCreate,
  icon: InvestorIcon
};
